import URLS from '../config/urls';
import BaseAPI from './BaseApi';


class RolesService {
    async getList(params: any): Promise<any> {
        try {
            const response = await BaseAPI.get(`${URLS.ROLES}`, { params });
            return response; // Retorna a resposta da API
        } catch (e) {
            return { error: "Erro ao trazer listagem" }; // Retorna um objeto de erro
        }
    }

    async createRoles(role: any): Promise<any> {
        try {
            const response = await BaseAPI.post(`${URLS.ROLES}`, role);
            return response; // Retorna a resposta da API
        } catch (error) {
            return { error: "Erro ao cadastrar", details: error };
        }
    }

    async editRoles(role: any, uuid: string | undefined): Promise<any> {
        try {
            const response = await BaseAPI.put(`${URLS.ROLES}/${uuid}`, role);
            return response; // Retorna a resposta da API
        } catch (error) {
            return { error: "Erro ao cadastrar", details: error };
        }
    }

    async getRolesByUuid(uuid: string): Promise<any> {
        try {
            const response = await BaseAPI.get(`${URLS.ROLES}/${uuid}`);
            return response; // Retorna a resposta da API
        } catch (e) {
            return { error: "Erro ao buscar dados" }; // Retorna um objeto de erro
        }
    }


    async deleteRoles(uuid: string): Promise<any> {
        try {
            const response = await BaseAPI.delete(`${URLS.ROLES}/${uuid}`);
            return response; // Retorna a resposta da API
        } catch (e) {
            return { error: "Erro ao deletar" }; // Retorna um objeto de erro
        }
    }
}

const rolesService = new RolesService();
export default rolesService;

